type UndoProps = React.SVGProps<SVGSVGElement> & {
  fillColor?: string;
};

export function Undo({ fillColor = "currentcolor", ...rest }: UndoProps) {
  return (
    <svg
      {...rest}
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.27708 13.3604C3.01736 13.3604 2.79965 13.2726 2.62396 13.0969C2.44826 12.9212 2.36042 12.7035 2.36042 12.4438C2.36042 12.184 2.44826 11.9663 2.62396 11.7906C2.79965 11.6149 3.01736 11.5271 3.27708 11.5271H8.86875C9.83125 11.5271 10.6677 11.2215 11.3781 10.6104C12.0885 9.99931 12.4438 9.23542 12.4438 8.31875C12.4438 7.40208 12.0885 6.63819 11.3781 6.02708C10.6677 5.41597 9.83125 5.11042 8.86875 5.11042H3.09375L4.83542 6.85208C5.00347 7.02014 5.0875 7.23403 5.0875 7.49375C5.0875 7.75347 5.00347 7.96736 4.83542 8.13542C4.66736 8.30347 4.45347 8.3875 4.19375 8.3875C3.93403 8.3875 3.72014 8.30347 3.55208 8.13542L0.252083 4.83542C0.160417 4.74375 0.0954861 4.64444 0.0572917 4.5375C0.0190972 4.43056 0 4.31597 0 4.19375C0 4.07153 0.0190972 3.95694 0.0572917 3.85C0.0954861 3.74306 0.160417 3.64375 0.252083 3.55208L3.55208 0.252083C3.72014 0.0840278 3.93403 0 4.19375 0C4.45347 0 4.66736 0.0840278 4.83542 0.252083C5.00347 0.420139 5.0875 0.634028 5.0875 0.89375C5.0875 1.15347 5.00347 1.36736 4.83542 1.53542L3.09375 3.27708H8.86875C10.3507 3.27708 11.6226 3.75833 12.6844 4.72083C13.7462 5.68333 14.2771 6.88264 14.2771 8.31875C14.2771 9.75486 13.7462 10.9542 12.6844 11.9167C11.6226 12.8792 10.3507 13.3604 8.86875 13.3604H3.27708Z"
        fill={fillColor}
      />
    </svg>
  );
}
